import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCalendar } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { faChartLine } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faClone } from "@fortawesome/free-solid-svg-icons/faClone";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons/faEyeSlash";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { faHashtag } from "@fortawesome/free-solid-svg-icons/faHashtag";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { faLifeRing } from "@fortawesome/free-solid-svg-icons/faLifeRing";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import { faListAlt } from "@fortawesome/free-solid-svg-icons/faListAlt";
import { faListUl } from "@fortawesome/free-solid-svg-icons/faListUl";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons/faRedoAlt";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { faStop } from "@fortawesome/free-solid-svg-icons/faStop";
import { faStream } from "@fortawesome/free-solid-svg-icons/faStream";
import { faTicketAlt } from "@fortawesome/free-solid-svg-icons/faTicketAlt";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";
import { faWindows } from "@fortawesome/free-brands-svg-icons/faWindows";
import { faPaypal } from "@fortawesome/free-brands-svg-icons/faPaypal";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faLanguage } from "@fortawesome/free-solid-svg-icons/faLanguage";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons/faAddressCard";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faChartBar } from "@fortawesome/free-solid-svg-icons/faChartBar";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faTasks } from "@fortawesome/free-solid-svg-icons/faTasks";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import { faPaintRoller } from "@fortawesome/free-solid-svg-icons/faPaintRoller";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons/faClipboardCheck";
import { faHandHoldingUsd } from "@fortawesome/free-solid-svg-icons/faHandHoldingUsd";
import { faBug } from "@fortawesome/free-solid-svg-icons/faBug";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faCertificate } from "@fortawesome/free-solid-svg-icons/faCertificate";
import { faTruckMoving } from "@fortawesome/free-solid-svg-icons/faTruckMoving";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faExclamation } from "@fortawesome/free-solid-svg-icons/faExclamation";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { faPiggyBank } from "@fortawesome/free-solid-svg-icons/faPiggyBank";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { faUserCog } from "@fortawesome/free-solid-svg-icons/faUserCog";
import { faThermometerHalf } from "@fortawesome/free-solid-svg-icons/faThermometerHalf";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCogs } from "@fortawesome/free-solid-svg-icons/faCogs";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faPalette } from "@fortawesome/free-solid-svg-icons/faPalette";
import { faSave } from "@fortawesome/free-solid-svg-icons/faSave";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faCocktail } from "@fortawesome/free-solid-svg-icons/faCocktail";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faStopCircle } from "@fortawesome/free-solid-svg-icons/faStopCircle";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faUserTie } from "@fortawesome/free-solid-svg-icons/faUserTie";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import { faTools } from "@fortawesome/free-solid-svg-icons/faTools";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons/faUserSecret";
import { faBuilding } from "@fortawesome/free-solid-svg-icons/faBuilding";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faCoins } from "@fortawesome/free-solid-svg-icons/faCoins";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faVimeo } from "@fortawesome/free-brands-svg-icons/faVimeo";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faGlobeEurope } from "@fortawesome/free-solid-svg-icons/faGlobeEurope";
import { faSmileBeam } from "@fortawesome/free-solid-svg-icons/faSmileBeam";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons/faAngleDoubleLeft";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons/faPlusSquare";
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
import { faMinusSquare } from "@fortawesome/free-solid-svg-icons/faMinusSquare";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faImages } from "@fortawesome/free-solid-svg-icons/faImages";
import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons/faCreditCard";
// import { faTurtle } from "@fortawesome/free-solid-svg-icons/faTurtle";
// import { faRabbitFast } from "@fortawesome/free-solid-svg-icons/faRabbitFast";
// import { faCoin } from "@fortawesome/free-solid-svg-icons/faCoin";
import { faStopwatch } from "@fortawesome/free-solid-svg-icons/faStopwatch";
import { faGift } from "@fortawesome/free-solid-svg-icons/faGift";
import { faRocket } from "@fortawesome/free-solid-svg-icons/faRocket";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons/faSlidersH";
// import { faTasksAlt } from "@fortawesome/free-solid-svg-icons/faTasksAlt";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons/faExchangeAlt";
import { faStarOfLife } from "@fortawesome/free-solid-svg-icons/faStarOfLife";
import { faCcStripe } from "@fortawesome/free-brands-svg-icons/faCcStripe";
import { faCcPaypal } from "@fortawesome/free-brands-svg-icons/faCcPaypal";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons/faShareAlt";
// import { faCreditCardFront } from "@fortawesome/free-solid-svg-icons/faCreditCardFront";
import { faForward } from "@fortawesome/free-solid-svg-icons/faForward";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faFileImage } from "@fortawesome/free-solid-svg-icons/faFileImage";
// import { faFileArchive } from "@fortawesome/free-solid-svg-icons/faFileArchive";
import { faPauseCircle } from "@fortawesome/free-solid-svg-icons/faPauseCircle";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons/faPlayCircle";
import { faFileExport } from "@fortawesome/free-solid-svg-icons/faFileExport";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpenText";
import { faBook } from "@fortawesome/free-solid-svg-icons/faBook";

library.add(
  faHashtag,
  faFileAlt,
  faMoneyBillAlt,
  faWindows,
  faApple,
  faExclamationCircle,
  faArrowRight,
  faSpinner,
  faDownload,
  faListAlt,
  faListUl,
  faRedoAlt,
  faUpload,
  faTicketAlt,
  faTrashAlt,
  faLayerGroup,
  faCheckCircle,
  faEye,
  faEyeSlash,
  faLifeRing,
  faSearch,
  faStream,
  faClone,
  faChartLine,
  faStop,
  faClock,
  faList,
  faFilePdf,
  faPaypal,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faSignInAlt,
  faSignOutAlt,
  faLanguage,
  faEnvelope,
  faPhone,
  faExclamationTriangle,
  faClock,
  faAddressCard,
  faUser,
  faUsers,
  faChartBar,
  faHome,
  faTasks,
  faFileInvoiceDollar,
  faPaintRoller,
  faHandHoldingUsd,
  faClipboardCheck,
  faBug,
  faEdit,
  faUniversity,
  faCertificate,
  faTruckMoving,
  faInfoCircle,
  faExclamation,
  faExternalLinkAlt,
  faPiggyBank,
  faGlobe,
  faUserCog,
  faThermometerHalf,
  faCheck,
  faCogs,
  faPlusCircle,
  faBan,
  faPalette,
  faSave,
  faUndo,
  faBell,
  faCocktail,
  faTimes,
  faTimesCircle,
  faCheckCircle,
  faStopCircle,
  faUserTie,
  faUserCircle,
  faTools,
  faCog,
  faUserSecret,
  faBuilding,
  faFileExcel,
  faRocket,
  faListUl,
  faCoins,
  faFacebookSquare,
  faTwitter,
  faYoutube,
  faInstagram,
  faVimeo,
  faLinkedin,
  faGlobeEurope,
  faChartLine,
  faSmileBeam,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faPlusSquare,
  faMinusSquare,
  faAngleRight,
  faImages,
  faTachometerAlt,
  faCreditCard,
  //   faTurtle,
  //   faRabbitFast,
  //   faCoin,
  faStopwatch,
  faGift,
  faSlidersH,
  //   faTasksAlt,
  faStarOfLife,
  faCloudUploadAlt,
  faExchangeAlt,
  faCcStripe,
  faCcPaypal,
  faShareAlt,
  //   faCreditCardFront,
  faForward,
  faQuestionCircle,
  faFileImage,
  //   faFileArchive,
  faFile,
  faPauseCircle,
  faPlayCircle,
  faFileExport,
  faClipboardList,
  faMinus,
  faArrowLeft,
  faPencilAlt,
  faEnvelopeOpenText,
  faBook
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
